'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _utils = require('../utils');

var _TransactionLifeCycle2 = require('../eth/TransactionLifeCycle');

var _TransactionLifeCycle3 = _interopRequireDefault(_TransactionLifeCycle2);

var _debug = require('debug');

var _debug2 = _interopRequireDefault(_debug);

var _Currency = require('./Currency');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)('dai:TransactionObject');

var TransactionObject = function (_TransactionLifeCycle) {
  (0, _inherits3.default)(TransactionObject, _TransactionLifeCycle);

  function TransactionObject(transaction, web3Service, nonceService) {
    var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        businessObject = _ref.businessObject,
        metadata = _ref.metadata;

    (0, _classCallCheck3.default)(this, TransactionObject);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TransactionObject.__proto__ || (0, _getPrototypeOf2.default)(TransactionObject)).call(this, businessObject));

    _this._transaction = transaction;
    _this._web3Service = web3Service;
    _this._nonceService = nonceService;
    _this._timeStampSubmitted = new Date();
    _this.metadata = metadata || {};
    _this._confirmedBlockCount = _this._web3Service.confirmedBlockCount();
    return _this;
  }

  (0, _createClass3.default)(TransactionObject, [{
    key: 'timeStampSubmitted',
    value: function timeStampSubmitted() {
      return this._timeStampSubmitted;
    }
  }, {
    key: 'timeStamp',
    value: function timeStamp() {
      return this._timeStampMined;
    }
  }, {
    key: 'fees',
    value: function fees() {
      return this._fees;
    }
  }, {
    key: 'mine',
    value: function mine() {
      var _this2 = this;

      if (!this._dataPromise) this._dataPromise = this._getTransactionData();
      return this._dataPromise.then(function () {
        return _this2._returnValue();
      });
    }
  }, {
    key: 'isFinalized',
    value: function isFinalized() {
      if (this._blockNumberWhenMined + this._confirmedBlockCount <= this._web3Service.blockNumber()) this.setFinalized();
      return (0, _get3.default)(TransactionObject.prototype.__proto__ || (0, _getPrototypeOf2.default)(TransactionObject.prototype), 'isFinalized', this).call(this);
    }
  }, {
    key: 'confirm',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._confirmedBlockCount;
        var newBlockNumber, newReceipt;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this._confirmedBlockCount = count;
                _context.next = 3;
                return this.mine();

              case 3:
                if (!(parseInt(count) <= 0)) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt('return');

              case 5:
                newBlockNumber = this.receipt.blockNumber + count;
                _context.next = 8;
                return this._web3Service.waitForBlockNumber(newBlockNumber);

              case 8:
                _context.next = 10;
                return this._web3Service.getTransactionReceipt(this.hash);

              case 10:
                newReceipt = _context.sent;

                if (!(newReceipt.blockHash !== this.receipt.blockHash)) {
                  _context.next = 13;
                  break;
                }

                throw new Error('transaction block hash changed');

              case 13:
                this.setFinalized();
                return _context.abrupt('return', this._returnValue());

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function confirm() {
        return _ref2.apply(this, arguments);
      }

      return confirm;
    }()
  }, {
    key: '_getTransactionData',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        var gasPrice, tx, label, revertMsg;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                gasPrice = void 0, tx = void 0;
                _context2.next = 4;
                return this._transaction;

              case 4:
                this.hash = _context2.sent;

                if (this.hash.hash) {
                  // When using websockets, the transaction hash is returned from this._transaction
                  // Otherwise, the tx receipt is returned. This corrects in such cases
                  this.hash = this.hash.hash;
                }
                this.setPending(); // set state to pending

                // when you're on a local testnet, the transaction will probably already
                // be mined by this point. but on other nets, you still have to wait for
                // it to be mined.

                if (!(!tx || !tx.blockHash)) {
                  _context2.next = 11;
                  break;
                }

                _context2.next = 10;
                return this._keepWaitingForTx();

              case 10:
                tx = _context2.sent;

              case 11:

                gasPrice = tx.gasPrice;
                this._timeStampMined = new Date();
                this._blockNumberWhenMined = tx.blockNumber;
                _context2.next = 16;
                return this._waitForReceipt();

              case 16:
                this.receipt = _context2.sent;

                if (!!this.receipt.gasUsed && !!gasPrice) {
                  this._fees = _Currency.ETH.wei(gasPrice).times(this.receipt.gasUsed);
                } else {
                  /*
                    console.warn('Unable to calculate transaction fee. Gas usage or price is unavailable. Usage = ',
                      receipt.gasUsed ? receipt.gasUsed.toString() : '<not set>',
                      'Price = ', gasPrice ? gasPrice.toString() : '<not set>'
                    );
                  */
                }

                if (!(this.receipt.status == '0x1' || this.receipt.status == 1)) {
                  _context2.next = 22;
                  break;
                }

                this.setMined();
                _context2.next = 26;
                break;

              case 22:
                label = this.metadata.contract ? this.metadata.contract + '.' + this.metadata.method : 'transaction';
                revertMsg = label + ' ' + this.hash + ' reverted';

                log(revertMsg + '\n' + (0, _stringify2.default)(this.receipt, null, '  '));
                throw new Error(revertMsg);

              case 26:
                _context2.next = 34;
                break;

              case 28:
                _context2.prev = 28;
                _context2.t0 = _context2['catch'](0);
                _context2.next = 32;
                return this._nonceService.setCounts();

              case 32:
                this.setError(_context2.t0);
                throw _context2.t0;

              case 34:
                return _context2.abrupt('return', this);

              case 35:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 28]]);
      }));

      function _getTransactionData() {
        return _ref3.apply(this, arguments);
      }

      return _getTransactionData;
    }()
  }, {
    key: '_waitForReceipt',
    value: function _waitForReceipt() {
      var _this3 = this;

      var retries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 15;
      var currentTry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      var result = _promise2.default.resolve(this._web3Service.getTransactionReceipt(this.hash));

      if (retries < 1) return result;
      return result.then(function (receipt) {
        if (receipt) return receipt;

        log('Receipt is null. Retrying ' + retries + ' more time(s)');
        return (0, _utils.promiseWait)(currentTry * 1500).then(function () {
          return _this3._waitForReceipt(retries - 1, currentTry + 1);
        });
      });
    }
  }, {
    key: '_keepWaitingForTx',
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
        var tx, startTime, i, elapsed;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                tx = void 0;
                startTime = new Date();

                log('waiting for transaction ' + this.hash.substring(8) + '... to mine');
                i = 0;

              case 4:
                if (!(i < 240)) {
                  _context3.next = 16;
                  break;
                }

                _context3.next = 7;
                return this._web3Service.getTransaction(this.hash);

              case 7:
                tx = _context3.sent;

                if (!(tx || {}).blockHash) {
                  _context3.next = 10;
                  break;
                }

                return _context3.abrupt('break', 16);

              case 10:
                log('not mined yet');
                _context3.next = 13;
                return (0, _utils.promiseWait)(5000);

              case 13:
                i++;
                _context3.next = 4;
                break;

              case 16:
                elapsed = (new Date() - startTime) / 1000;

                log('mined ' + this.hash.substring(8) + '... done in ' + elapsed + 's');
                return _context3.abrupt('return', tx);

              case 19:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function _keepWaitingForTx() {
        return _ref4.apply(this, arguments);
      }

      return _keepWaitingForTx;
    }()
  }]);
  return TransactionObject;
}(_TransactionLifeCycle3.default);

exports.default = TransactionObject;